// @ts-strict-ignore
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-select-all-option',
    templateUrl: './select-all-option.component.html',
    styleUrls: ['./select-all-option.component.scss'],
    standalone: false
})
export class SelectAllOptionComponent {
  @Input() public model: FormControl;
  @Input() public values: any[] = [];
  @Input() public text: string = 'Select All';
  @Input() public valueKey: string = 'value';

  public isChecked(): boolean {
    if (!this.values) return false;

    return this.model.value && this.values.length && this.model.value.length === this.values.length;
  }

  public isIndeterminate(): boolean {
    if (!this.values) return true;

    return (
      this.model.value &&
      this.values.length &&
      this.model.value.length &&
      this.model.value.length < this.values.length
    );
  }

  public toggleSelection(change: MatCheckboxChange): void {
    this.model.setValue(change.checked ? this.values?.map((v) => v[this.valueKey]) ?? [] : []);
  }
}
